var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.sidebar)?_c('sidebar'):_vm._e(),_c('v-main',{class:[{'background': _vm.withBg}, 'background-color']},[(_vm.toolbar)?_c('toolbar'):_vm._e(),_c('router-view')],1),_c('kimsa-toast'),(_vm.footer)?_c('kimsa-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }